import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { conditionalStyle, px2rem, responsive } from '@/theme';

import type { LineProps } from './Summary';

import { ReactComponent as EditSvg } from '@/assets/edit.svg';

export const HeaderWrapper = styled(Flex)`
  align-items: center;
  ${responsive('justify-content', 'center', 'flex-start')}
`;

export const Header = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    padding: ${theme.spacing(2, 1, 2, 0)};
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${px2rem(20)};
  `}
`;

export const EditIcon = styled(EditSvg)`
  height: 20px;
`;

export const Section = styled(Flex)`
  ${responsive('flex-direction', 'column', 'row')}

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    padding: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};

    ${responsive('grid-gap', 0, theme.spacing(2))}
    ${responsive('row-gap', theme.spacing(2), 0)}
  
    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const Entry = styled(Box)`
  ${responsive('width', '100%', '50%')}
`;

export const Line = styled(Typography)<Pick<LineProps, 'isBold'>>`
  word-break: normal;
  word-wrap: break-word;
  ${({ isBold, theme }) => css`
    ${conditionalStyle(isBold, 'font-weight', theme.fontWeights.bold)}
  `}
`;

export const IconWrapper = styled(Box)<{ disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
